var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCityManager({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22H4.07997C2.91997 22 1.96997 21.07 1.96997 19.93V5.08998C1.96997 2.46998 3.91997 1.27998 6.30997 2.44998L10.75 4.62998C11.71 5.09998 12.5 6.34998 12.5 7.40998V22ZM12.5 22H18.81C20.97 22 21.97 21 21.97 18.84V15.06C21.97 14.99 21.97 14.93 21.96 14.87C21.9 12.95 20.82 12.27 19.5 11.98L17.47 11.53L12.97 10.52L12.5 10.42V22ZM5.49997 8.99998H8.96997M5.49997 13H8.96997",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.47 11.53V14.75M17.47 11.53L12.97 10.52V14.75C12.97 15.99 13.98 17 15.22 17C16.46 17 17.47 15.99 17.47 14.75M17.47 11.53L19.5 11.98C20.82 12.27 21.9 12.95 21.96 14.87C21.9296 15.4441 21.6805 15.9847 21.2639 16.3808C20.8473 16.777 20.2948 16.9985 19.72 17C18.48 17 17.47 15.99 17.47 14.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityManager);
export default __webpack_public_path__ + "static/media/city_manager.5bc3b774638a59d9c65030a46c1db108.svg";
export { ForwardRef as ReactComponent };